'use es6';
/* Works like a simplified RxJS subject */

export default class ValueBuffer {
  constructor(func) {
    this.resetTimer = () => {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.broadcastValues, this.timeout);
      }
    };

    this.broadcastValues = () => {
      if (this.callback) this.callback(this.buffer);
      this.buffer = [];
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
    };

    this.next = value => {
      this.buffer.push(value);

      if (!this.timer) {
        this.timer = setTimeout(this.broadcastValues, this.timeout);
      } else {
        this.resetTimer();
      }
    };

    this.buffer = [];
    this.timer = null;
    /* Allow only single subscriber for now */

    this.callback = func;
  }

}
ValueBuffer.timeout = 1000;